import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Tenants/Table";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
    FilterTableWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import ReserveTenantTable from "../../Components/Tenants/ReserveTenantTable";
import { toast } from "react-toastify";
import CancelReservation from "../../Components/Tenants/Details/CancelReservation";
import MoveInManually from "../../Components/Tenants/Details/MoveInManually";
import SideModal from "../../Components/SideModal";
import MoveInReschedule from "../../Components/Tenants/Details/MoveInReschedule";
import ViewReserveModal from "../../Components/Tenants/Details/ViewReserveModal";

const ReserveTenantListing = () => {
    const user = useSelector((state) => state.UserReducer.user);
    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const [isFocused, setIsFocused] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState();
    const [selectedProperty, setSelectedProperty] = useState(property);
    const [isCancelReservation, setIsCancelReservation] = useState(false);
    const [isMoveIn, setIsMoveIn] = useState(false);
    const [isMoveInReschedule, setIsMoveInReschedule] = useState(false);
    const [viewDetail, setViewDetail] = useState(false);

    const query = `propId=${selectedProperty?.id}&searchVal=&filter=R`;

    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/tenant/list/web?${query}`,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) error = true;
        else {
            setApiData(res?.data?.list);
            setIsFocused(true);
        }
    };

    const getError = () => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getListMutate();
        }, 100);
        return () => clearTimeout(handler);
    }, [selectedProperty]);

    //------- Cancel Reservation Model -------
    const CancelReservationFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/tenant/reserve/cancel`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const cancelReservationSuccess = (data) => {
        getListMutate()
        setIsCancelReservation(false);
        toast.success(data?.data?.msg || "Success");
    };

    const cancelReservationError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const {
        isLoading: cancelReservationLoading,
        mutate: cancelReservationMutate,
    } = useMutation(CancelReservationFunction, {
        onSuccess: cancelReservationSuccess,
        onError: cancelReservationError,
    });

    //------- Move In Model -------
    const MoveInFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/tenant/manually/movein`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const moveInSuccess = (data) => {
        getListMutate()
        setIsMoveIn(false);
        setIsMoveInReschedule(false)
        toast.success(data?.data?.msg || "Success");
    };

    const moveInError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const {
        isLoading: moveInLoading,
        mutate: moveInMutate,
    } = useMutation(MoveInFunction, {
        onSuccess: moveInSuccess,
        onError: moveInError,
    });

    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        {"Move-In Pending"}
                        <Underline />
                    </BoxTitle>
                </BoxHead>

                {!error && !isLoading && apiData && (
                    // <FilterTableWrapper>
                    <TableWrapper>
                        <ReserveTenantTable
                            apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            userType={user.userType}
                            setIsCancelReservation={setIsCancelReservation}
                            setIsMoveIn={setIsMoveIn}
                            setIsMoveInReschedule={setIsMoveInReschedule}
                            setViewDetail={setViewDetail}
                        />
                        {(error || apiData?.length == 0) && !isLoading && (
                            <NotFoundModel />
                        )}
                    </TableWrapper>
                    // </FilterTableWrapper>
                )}
                {(isLoading || isRefetching) && <Loading />}
                {error && !isLoading && <NotFoundModel />}
                {isCancelReservation && (
                    <CancelReservation
                        setIsCancelReservation={setIsCancelReservation}
                        cancelReservationLoading={cancelReservationLoading}
                        cancelReservationMutate={cancelReservationMutate}
                        selectedData={selectedData}
                    />
                )}
                {/* {isMoveIn && (
                    <MoveInManually
                        setIsMoveIn={setIsMoveIn}
                        moveInLoading={moveInLoading}
                        moveInMutate={moveInMutate}
                        selectedData={selectedData}
                    />
                )} */}
                <SideModal
                    isOpen={isMoveIn}
                    onClose={() => setIsMoveIn(false)}
                >
                    <MoveInManually
                        setIsMoveIn={setIsMoveIn}
                        isMoveIn={isMoveIn}
                        selectedData={selectedData}
                        moveInLoading={moveInLoading}
                        moveInMutate={moveInMutate}
                    />
                </SideModal>
                <SideModal
                    isOpen={isMoveInReschedule}
                    onClose={() => setIsMoveInReschedule(false)}
                >
                    <MoveInReschedule
                        setIsMoveInReschedule={setIsMoveInReschedule}
                        isMoveInReschedule={isMoveInReschedule}
                        selectedData={selectedData}
                        moveInLoading={moveInLoading}
                        moveInMutate={moveInMutate}
                    />
                </SideModal>
                <SideModal
                    isOpen={viewDetail}
                    onClose={() => setViewDetail(false)}
                >
                    <ViewReserveModal
                        setViewDetail={setViewDetail}
                        viewDetail={viewDetail}
                        selectedData={selectedData}
                    />
                </SideModal>
            </BoxContainer>
        </>
    );
};

const TableWrapper = tw.h1`my-8 border bg-white rounded-md `;

export default ReserveTenantListing;
